// Dynamic API URL: uses current origin when accessed from a different domain
// than the build-time REACT_APP_BACKEND_URL (e.g., custom domain deployments)
export const API_URL = (() => {
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  if (typeof window !== 'undefined' && envUrl && window.location.origin !== envUrl) {
    return window.location.origin;
  }
  return envUrl || '';
})();
